export const successIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
    <path
      d="M12.9856 1.61401C6.70326 1.61401 1.61035 6.70692 1.61035 12.9893C1.61035 19.2717 6.70324 24.3646 12.9856 24.3646C19.2681 24.3646 24.3609 19.2717 24.3609 12.9893C24.3609 6.70692 19.2681 1.61401 12.9856 1.61401ZM19.6401 9.71392L11.3717 17.8761L6.24026 12.8742L7.86517 11.1453L11.3731 14.6532L18.0023 8.02408L19.6401 9.71392Z"
      fill="#22E015"
    />
  </svg>
)

export const errorIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
    <path
      d="M13 1.625C6.71836 1.625 1.625 6.71836 1.625 13C1.625 19.2816 6.71836 24.375 13 24.375C19.2816 24.375 24.375 19.2816 24.375 13C24.375 6.71836 19.2816 1.625 13 1.625ZM12.9848 20.1094C12.2002 20.1094 11.5654 19.4746 11.5654 18.6875C11.5654 17.9004 12.2002 17.2656 12.9848 17.2656C13.7693 17.2656 14.4041 17.9004 14.4041 18.6875C14.4041 19.4746 13.7693 20.1094 12.9848 20.1094ZM14.4041 13.7109C14.4041 14.1045 14.0867 14.4219 13.6932 14.4219H12.2738C11.8828 14.4219 11.5629 14.1045 11.5629 13.7109V6.60156C11.5629 6.20801 11.8803 5.89062 12.2738 5.89062H13.6932C14.0842 5.89062 14.4041 6.20801 14.4041 6.60156V13.7109Z"
      fill="#FD3624"
    />
  </svg>
)
